import { ImageComponent } from 'BreetComponents';
import { type IDropDownItem } from 'BreetHelpers';

const DropdownItemNetwork = ({ item }: { item: IDropDownItem }) => (
	<>
		<span className='dropdown_content_item_options_item_flag'>
			<ImageComponent src={item.icon as string} />
		</span>
		<span className='dropdown_content_item_options_item_name'>{item.name}</span>
		<span className='dropdown_content_item_options_item_flag'>{item.code}</span>
	</>
);

export default DropdownItemNetwork;
